// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createStore, createHook, type Store, createContainer } from '@atlassian/react-sweet-state';
import { type Actions, actions } from './actions.tsx';
import type { QueryConfig, State } from './types.tsx';

const storeId = 'RELAY_APOLLO_MIGRATION_STORE';

const initialState = {
	queries: [],
} as const;

// @ts-expect-error - TS2322 - Type 'Store<{ readonly queries: readonly []; }, Record<string, ActionThunk<{ readonly queries: readonly []; }, { readonly registerOrUpdateQuery: RegisterOrUpdateQueryAction; readonly setQueryData: SetQueryDataAction; ... 4 more ...; readonly forceCacheRecheck: ForceCacheRecheckAction; }>>>' is not assignable to type 'Store<State, Actions>'.
const QueriesStore: Store<State, Actions> = createStore({
	name: storeId,
	initialState,
	// @ts-expect-error - TS2322 - Type '{ readonly registerOrUpdateQuery: RegisterOrUpdateQueryAction; readonly setQueryData: SetQueryDataAction; readonly setQueryLoading: SetQueryLoadingAction; readonly setQueryError: SetQueryErrorAction; readonly removeQuery: RemoveQueryAction; readonly updateQuery: UpdateQueryAction; readonly forceCacheRecheck: ForceCa...' is not assignable to type 'Record<string, ActionThunk<{ readonly queries: readonly []; }, { readonly registerOrUpdateQuery: RegisterOrUpdateQueryAction; readonly setQueryData: SetQueryDataAction; ... 4 more ...; readonly forceCacheRecheck: ForceCacheRecheckAction; }>>'.
	actions,
});

export const useGetQueries = createHook(QueriesStore, {
	selector: (state: State): QueryConfig[] => state.queries,
});

export const useGetQueryById = createHook(QueriesStore, {
	selector: (state: State, id: string): QueryConfig | typeof undefined =>
		state.queries.find((q) => q.id === id),
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const QueriesContainer = createContainer<State, Actions, Record<any, any>>(QueriesStore);
